var render = function render(){var _vm=this,_c=_vm._self._c;return (Boolean(_vm.text))?_c('v-alert',{staticClass:"ma-0 text-start",attrs:{"border":"left","color":"#EF3E36","transition":"scroll-y-transition","dense":"","text":""}},[_c('small',{staticClass:"font-weight-medium",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }